<template>
  <div :ref="'r' + index" style="">
    <header>
      <img class="bowie-house" src="./assets/images/Bowie_House_Logo.png" />
    </header>

    <div>
      
      <ul>
        <li>
          <h3>HOTEL GUESTS</h3>
          <!-- Last Name Room Number -->
          <div class="form-field">
            <input
              v-model="form.guest_last_name"
              class="input-text"
              placeholder="Type here..."
              type="text"
            />
            <label class="label">LAST NAME</label>
          </div>

          <div class="form-field">
            <input
              v-model="form.room_number"
              class="input-text"
              type="text"
            />
            <label class="label">ROOM NUMBER</label>
          </div>

          <div>
            <span v-if="!guest_signin_valid" class="error-text">Valid name and room number required.</span><br>
            <button
              :style="'background: ' + color_background_button + '; color: ' + color_text_button"
              class="btn top-btn"
              type="button"
              @click="emitRegistrationMethodData(2)"
            >SUBMIT</button>
            <p class="text-center text-14 mb-0 terms-text">
              *by clicking submit I agree to the 
              <span class="text-link" @click="selectTermsOfService(true)"><u>terms and conditions</u></span>
            </p>
          </div>

          <!-- /LNRN -->
        </li>
        <li>
          <h3>VISITORS</h3>
          <!-- Last Name Zip Code Email -->
          <div class="form-field">
            <input
              v-model="form.visitor_last_name"
              class="input-text"
              placeholder="Type here..."
              type="text"
            />
            <label class="label">FIRST AND LAST NAME</label>
          </div>

          <div class="form-field">
            <input
              v-model="form.zip"
              class="input-text"
              type="text"
            />
            <label class="label">ZIPCODE</label>
          </div>
          <span v-if="!form_validation.valid_zip" class="error-text">Please enter a valid zipcode.</span><br>

          <div class="form-field email">
            <input
              v-model="form.email_address"
              class="input-text"
              type="text"
            />
            <label class="label">EMAIL</label>
          </div>
          <span v-if="!form_validation.valid_email" class="error-text">Please enter a valid email address.</span><br>
          
          <div class="checkbox-marketing">
            <label for="checkbox-marketing">
              <input 
                type="checkbox" 
                name="email_consent" 
                id="email_consent" 
                v-model="form.consent" 
              />
              <span>Receive updates about happenings and promotions.</span>
              <br><span v-if="!form_validation.valid_consent" class="error-text">Required to continue.</span><br>
            </label>
          </div>
          
          <span v-if="!visitor_signin_valid" class="error-text">Valid name, zipcode and email required.</span><br>

          <div>
            <button
              :style="'background: ' + color_background_button + '; color: ' + color_text_button"
              class="btn top-btn"
              type="button"
              @click="emitRegistrationMethodData(3)"
            >SUBMIT</button>
            <p class="text-center text-14 mb-0 terms-text">
              *by clicking submit I agree to the
              <span class="text-link" @click="selectTermsOfService(true)"><u>terms and conditions</u></span>
            </p>
          </div>

          <!-- /LN ZC E -->
        </li>
        <li>
          <h3>EVENTS</h3>
          <!-- Last Name Access Code -->
          <div class="form-field">
            <input
              v-model="form.events_last_name"
              class="input-text"
              placeholder="Type here..."
              type="text"
            />
            <label class="label">NAME</label>
          </div>

          <div class="form-field">
            <input
              v-model="access_code"
              class="input-text"
              type="text"
            />
            <label class="label">ACCESS CODE</label>
          </div>

          <div>
            <span v-if="!access_code_valid" class="error-text">Valid name and access code required.</span><br>
            <button
              :style="'background: ' + color_background_button + '; color: ' + color_text_button"
              class="btn top-btn"
              type="button"
              @click="emitRegistrationMethodData(4)"
            >SUBMIT</button>
            <p class="text-center text-14 mb-0 terms-text">
              *by clicking submit I agree to the 
              <span class="text-link" @click="selectTermsOfService(true)"><u>terms and conditions</u></span>
            </p>
          </div>

          <!-- /LNAC -->
        </li>
      </ul>

      <div class="bowie"></div>
      <div
        v-if="tos_selected"
        class="terms-of-service text-left pt-20"
      >
        <div v-html="terms_of_service"></div>
        <div class="mt-30 text-center">
          <button class="btn-close" @click="selectTermsOfService(false)">
            CLOSE
          </button>
        </div>
      </div>
    </div>
    <div class="fw-container">
      <img class="fw-logo" src="./assets/images/Fort_Worth_Badge.png" />
    </div>
  </div>
  <!-- rm -->
</template>
<script>
import Axios from 'axios';

export default {
  name: "custom_template_bowie",
  props: [
    "index",
    "selected",
    "selected_tos",
    "color_background_button",
    "color_text_button",
    "registration_method",
    "portal",
    "terms_of_service"
  ],
  data() {
    return {
      access_code: null,
      access_code_valid: true,
      selected_error: false,
      tos_selected: false,
      form: {
        first_name: "",
        last_name: "",
        room_number: "",
        email_address: "",
        consent: false,
        marketing: false,
        zip: null
      },
      guest_signin_valid: true,
      visitor_signin_valid: true,
      revinate: {
        token: '9d80d338-1fcc-4096-9800-715059cc425b',
        url: 'https://contact-api.inguest.com/api/add-contacts-to-lists'
      },
      form_validation: {
        valid_email: true,
        valid_room_number: true, 
        valid_zip: true,
        valid_consent: true
      }
    };
  },
  methods: {
    selectTermsOfService: function (input) {
      this.tos_selected = input;
    },
    emitRegistrationMethodData: function (registrationId) {

      var emitted = {
        registration_method_id: registrationId,
        rateplan_id: null,
        email_address: null,
        last_name: null,
        first_name: null,
        room_number: null,
        access_code: null,
        zip: null
      };

      if (registrationId == "2") {
        const registration_method = this.portal.registration_methods.find(registration_method => registration_method.registration_method_id === 2);
        const rateplan_id = registration_method.rate_plans[0].rateplan_id;
        this.guest_signin_valid = this.form.guest_last_name && this.form.room_number;
        if (this.guest_signin_valid) {
          emitted.last_name = this.form.guest_last_name;
          emitted.room_number = this.form.room_number;
          emitted.rateplan_id = rateplan_id;
        } else {
          return
        }
      } else if (registrationId == "3") {
        const registration_method = this.portal.registration_methods.find(registration_method => registration_method.registration_method_id === 3);
        const rateplan_id = registration_method.rate_plans[0].rateplan_id;
        if (this.validateVisitorConnect()) {
          // grab entry from 'last_name' field because historically this was the field
          // break it up into two parts
          let firstAndLastName = this.form.visitor_last_name.split(' ')

          // if there is more than 1 part assume the first is first name
          // and second is last name. if just one part send it as last name
          if(firstAndLastName.length > 1) {
            emitted.first_name = firstAndLastName[0];
            emitted.last_name = firstAndLastName[1]
          } else {
            emitted.last_name = this.form.visitor_last_name;
          }

          emitted.email_address = this.form.email_address;
          emitted.zip = this.form.zip;
          emitted.consent = this.form.consent;
          emitted.rateplan_id = rateplan_id;
        } else {
          return 
        }
      } else if (registrationId == "4") {
        this.access_code_valid = this.form.events_last_name && this.access_code;
        if (this.access_code_valid) {
          emitted.last_name = this.form.events_last_name;
          emitted.access_code = this.access_code;
        } else {
          return 
        }
      }

      if (this.form.consent && registrationId == '3') {
        const revinate_data = {
          tokens: [ this.revinate.token ],
          contacts: [
            {
              ...(emitted.first_name && { first_name: emitted.first_name }),
              ...(emitted.last_name && { last_name: emitted.last_name }),
              ...(emitted.zip && { zip: emitted.zip }),
              ...(emitted.email_address && { email: emitted.email_address }),
                subscribed: emitted.consent
            }
        ]
      };


        Axios.post(this.revinate.url, revinate_data).then(response => {
          this.$emit('emitRegistrationMethodData', emitted);
        }).catch( error => {
          this.$emit('error', 'Error registering with email address.');
        });
      } else {
        this.$emit('emitRegistrationMethodData', emitted);
      }
    },
    validateVisitorConnect: function() {
      this.visitor_signin_valid = this.form.visitor_last_name && this.form.zip && this.form.email_address;
      if (!this.visitor_signin_valid) {
        return false;
      }
      this.form_validation.valid_zip = this.isNumericValue(this.form.zip);
      this.form_validation.valid_email = this.emailIsValid();
      this.form_validation.valid_consent = this.form.consent;
      return this.form_validation.valid_email && this.form_validation.valid_zip && this.form_validation.valid_consent && this.form.visitor_last_name
        && this.form.zip && this.form.email_address;
    },
    emailIsValid: function () {
      return /\S+@\S+\.\S+/.test(this.form.email_address);
    },
    isNumericValue: function(input) {
      return /^\d+$/.test(input);
    }
  },
};
</script>
<style>
@font-face { 
  font-family: "Plantin MT Pro";
  src: url(./assets/fonts/PlantinMTPro/PlantinMTPro-Regular.otf); 
}
@font-face { 
  font-family: "Plantin MT Pro Italic";
  src: url(./assets/fonts/PlantinMTPro/PlantinMTPro-Italic.otf); 
}
@font-face { 
  font-family: "Sofia Sans Condensed Italic";
  src: url(./assets/fonts/SofiaSansCondensed/SofiaSansCondensed-Italic-VariableFont_wght.ttf); 
}
@font-face { 
  font-family: "Sofia Sans Condensed";
  src: url(./assets/fonts/SofiaSansCondensed/SofiaSansCondensed-VariableFont_wght.ttf); 
}

#app {
  margin: 0;
  padding: 0;
}

.bowie {
  height: 100%;
  position: fixed;
  z-index: -1;
  bottom:0;
  width:100%; 
  background-image: url(assets/images/horse_image.jpg);
  background-size: cover;
  background-repeat: no-repeat;
}

.bowie-house {
  width: 100%;
  height: auto;
}

.input-text {
  border: 0;
  outline: 0;
  background: transparent;
  border-bottom: 2px solid #341514;
  border-radius: 0px;
  font-family: "Plantin MT Pro";
  padding: .5rem;
}

.label {
  display: inline-block;
  margin-top: .3rem;
  color: #6D3E34;
  font-family: "Sofia Sans Condensed"
}

.email {
  margin-bottom: -.5rem;
}

.terms-text, .checkbox-marketing {
  color: #6D3E34;
  font-family: "Plantin MT Pro Italic";
  font-weight: normal;
  font-size: small;
}

.checkbox-marketing {
  margin-bottom: 1rem;
}

.fw-container {
  height: 4rem;
  width: 6rem;
  margin: auto;

}

.fw-logo {
  width: 100%;
  height: auto;
}

.terms-of-service {
  background-color: white;
  width: 75%;
  max-height: 20rem;
  border: 1px solid #6D3E34;
  display: inline-block;
  overflow-x: auto;
  padding: 2rem;
  margin: 2rem;
}

.text-link {
  cursor: pointer;
}

.error-text {
  color: red;
}

input[type="checkbox"] {
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 1px solid #6D3E34;
  cursor: pointer;
  margin: 0px 10px -5px 0px;
  text-wrap: nowrap;
}

h3 {
  color: #6D3E34;
  font-family: "Plantin MT Pro";
  font-weight: 100;
  letter-spacing: 3px;
  font-size: x-large;
}

header {
  height: 4rem;
  width: 18rem;
  margin: auto;
  padding-top: 2rem;
}

button {
  all: unset;
  background-color: #6D3E34;
  padding: .5rem 4rem .5rem 4rem;
  color: white;
  cursor: pointer;
}

button, .label {
  font-family: "Sofia Sans Condensed";
  letter-spacing: 5px;
  font-weight: 600;
  font-size: large;
  margin: auto;
  margin-top: 1rem;
  margin-bottom: 1rem;
}

ul, li {
  list-style: none;
  overflow: hidden;
}

ul {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  flex-shrink: 0;
  gap: 3rem;
  padding: 1rem;
}

li {
  max-width: 24rem;
  min-width: 24rem;
  min-height: 34rem;
  border: 4.5px solid #341514;
  padding: 1rem 4rem 1rem 4rem;
  background-color: white;
  box-sizing: border-box;
  max-width: 32rem;
  margin-bottom: 2rem;
}

@media screen and (min-width: 768px) {
  ul {
    flex-wrap: wrap;
  }
}

@media screen and (min-width: 1700px) {
    ul {
      flex-wrap: wrap;
    }

    .fw-container {
      margin-top: 5rem;
      width: 8rem;
    }

    header {
      width: 22rem;
      margin-top: 3rem;
      margin-bottom: 3rem;
  }
}

</style>
